import BetTextKeys from '~/components/sportsbook/lobby/components/bet/sportsbook-bet-text-keys';

const betEnumToTextKeyMap: { [x: string]: string } = {
	COMBINATION_1: BetTextKeys.SYSTEM_BET_COMBINATION_1_LABEL,
	COMBINATION_2: BetTextKeys.SYSTEM_BET_COMBINATION_2_LABEL,
	COMBINATION_3: BetTextKeys.SYSTEM_BET_COMBINATION_3_LABEL,
	COMBINATION_4: BetTextKeys.SYSTEM_BET_COMBINATION_4_LABEL,
	COMBINATION_5: BetTextKeys.SYSTEM_BET_COMBINATION_5_LABEL,
	COMBINATION_6: BetTextKeys.SYSTEM_BET_COMBINATION_6_LABEL,
	COMBINATION_7: BetTextKeys.SYSTEM_BET_COMBINATION_7_LABEL,
	COMBINATION_8: BetTextKeys.SYSTEM_BET_COMBINATION_8_LABEL,
	COMBINATION_9: BetTextKeys.SYSTEM_BET_COMBINATION_9_LABEL,
	COMBINATION_10: BetTextKeys.SYSTEM_BET_COMBINATION_10_LABEL,
	COMBINATION_11: BetTextKeys.SYSTEM_BET_COMBINATION_11_LABEL,
	COMBINATION_12: BetTextKeys.SYSTEM_BET_COMBINATION_12_LABEL,
	COMBINATION_13: BetTextKeys.SYSTEM_BET_COMBINATION_13_LABEL,
	COMBINATION_14: BetTextKeys.SYSTEM_BET_COMBINATION_14_LABEL,
	COMBINATION_15: BetTextKeys.SYSTEM_BET_COMBINATION_15_LABEL,
	COMBINATION_16: BetTextKeys.SYSTEM_BET_COMBINATION_16_LABEL,
	COMBINATION_17: BetTextKeys.SYSTEM_BET_COMBINATION_17_LABEL,
	COMBINATION_18: BetTextKeys.SYSTEM_BET_COMBINATION_18_LABEL,
	COMBINATION_19: BetTextKeys.SYSTEM_BET_COMBINATION_19_LABEL,
	COMBINATION_20: BetTextKeys.SYSTEM_BET_COMBINATION_20_LABEL
};

export default betEnumToTextKeyMap;
